<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :footer="footer"
    :config="config"
    ref="table"
  >
  </cTable>
</template>

<script>
import {
  getDetails,
  hangBill,
  deleteDetails,
} from "@/api/finance/hw_bill_branch";
import { getExpense } from "@/api/finance/expense";
import { getCountry } from "@/api/system/country";

import cTable from "@/base/common/index";

export default {
  components: {
    cTable,
  },
  props: {
    rows: {
      type: Object,
    },
  },
  data() {
    return {
      config: {
        slot: "div",
        rows: this.rows,
      },
      totalAmount: [],
      methods: {
        list: (p) => {
          p.id = this.config.rows.id;
          return getDetails(p);
        },
        getExpense,
        getCountry,
        hangBill,
        deleteDetails,

        // afterHandleList() {
        //   this.getTable().setAllRowExpand(true);
        // },
        // beforeHandleList: ({ data }) => {
        // if (this.totalAmount.length == 0) {
        //   this.totalAmount.push(
        //     {
        //       text: this.$t("total"),
        //       replace_currency: "CNY",
        //       total_amount: data.total_cny
        //     },
        //     {
        //       text: this.$t("total"),
        //       replace_currency: "USD",
        //       total_amount: data.total_usd
        //     }
        //   );
        // }
        // }
      },
      modals: {
        hang: {
          methods: {
            ok({ row, close }) {
              let data = row;
              data.ids = this.$page.selectAll.map((item) => item.id);
              data.id = this.$page.config.rows.id;
              this.$page.handleRequestMethods("hangBill", data).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                });
                this.$page.getList();
                close();
              });
            },
          },
          config: {
            modalBind: {
              width: 600,
            },
            formBind: {
              labelWidth: 80,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              remarks: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [{ remarks: 24 }],
          fields: [
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("Remarks");
              },
              bind: {
                type: "textarea",
                rows: 5,
              },
            },
          ],
        },
        add: {
          methods: {
            ok({ row, close }) {
              this.$page.handleRequestMethods("addB2bBill", row).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                });
                this.$page.getList();
                close();
              });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              client_ids: [
                {
                  required: true,
                  type: "number",
                  message: this.$t("select") + this.$t("clientName"),
                  trigger: "change",
                },
              ],
              name: [
                {
                  required: true,
                  message: this.$t("enter") + this.$t("codNAme"),
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [{ client_ids: 24 }, { name: 24 }],
          fields: [
            {
              name: () => this.$t("clientName"),
              key: "client_ids",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("order_number"),
              options: [],
              config: { label: "account", value: "id" },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getB2bBillUSer")
                  ).payload;
                  this.$forceUpdate();
                },
              },
            },
            {
              name: () => this.$t("codNAme"),
              key: "name",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("codNAme"),
            },
          ],
        },
        update: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("updateB2bBill", row)
                .then((res) => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg,
                  });
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              name: [
                {
                  required: true,
                  message: "Please Enter name",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [{ name: 24 }, { remarks: 24 }],
          fields: [
            {
              name: () => this.$t("codNAme"),
              key: "name",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("codNAme"),
            },
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Remarks"),
              bind: {
                rows: 5,
                type: "textarea",
              },
            },
          ],
        },
        writeOff: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = row;
              delete data.bill_order;
              data.airway_number = this.selectAll.map(
                (item) => item.airway_number
              );
              this.$page
                .handleRequestMethods("b2bWriteOff", data)
                .then((res) => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg,
                  });
                  this.$page.getList();
                  close();
                });
            },
            checkTable({ row }) {
              let amount = 0;
              row.map((item) => {
                amount += parseFloat(item.amount);
                return;
              });
              this.$refs["form"].formData.check_amount = amount;
              this.$forceUpdate();
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 120,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              contract_header: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                  type: "number",
                },
              ],
              check_amount: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
              check_amount_currency: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                },
              ],
              payment_bank: [
                {
                  required: true,
                  message: "cannot be empty",
                  type: "number",
                  trigger: "change",
                },
              ],
              payment_time: [
                {
                  required: true,
                  message: "cannot be empty",
                  type: "date",
                  trigger: "change",
                },
              ],
            },
          },
          grid: [
            { contract_header: 24 },
            { payment_bank: 24 },
            { payment_time: 24 },
            { check_amount: 24 },
            { check_amount_currency: 24 },
            { transaction_id: 24 },
            // { search_cnbnum: 24 }
          ],
          fields: [
            {
              name: () => this.$t("contract_title"),
              key: "contract_header",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("contract_title"),
              options: [],
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods(
                      "getB2bContractHeader"
                    )
                  ).payload;
                  this.$forceUpdate();
                },
              },
            },
            {
              name: () => this.$t("bank"),
              key: "payment_bank",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("bank"),
              options: [],
              config: {
                label({ row }) {
                  return row.account_type + "(" + row.bank_code + ")";
                },
                value: "id",
              },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getBank")
                  ).payload;
                  this.$forceUpdate();
                },
              },
            },
            {
              name: () => this.$t("paid_time"),
              key: "payment_time",
              component: "DatePicker",
              placeholder: () => this.$t("select") + this.$t("paid_time"),
              bind: {
                type: "datetime",
                format: "yyyy-MM-dd HH:mm:ss",
              },
            },
            {
              name: () => this.$t("check_amount"),
              key: "check_amount",
              component: "InputNumber",
              bind: {
                min: 0,
                step: 0.0001,
                style: "width:100%",
              },
              default: 0,
            },
            {
              name: () => this.$t("check_amount_currency"),
              key: "check_amount_currency",
              component: "Select",
              placeholder: () =>
                this.$t("select") + this.$t("check_amount_currency"),
              options: [
                { label: this.$t("to_rmb"), value: "CNY" },
                { label: this.$t("to_usd"), value: "USD" },
              ],
            },
            {
              name: () => this.$t("transaction_id"),
              key: "transaction_id",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("transaction_id"),
            },
            // {
            //   name: () => this.$t("order_number"),
            //   key: "search_cnbnum",
            //   component: "Input",
            //   placeholder: () =>
            //     this.$t("enter") + this.$t("order_number") + this.$t("search"),
            //   methods: {
            //     "on-search"({ formData }) {
            //       let that = this.$page.getModal("writeOff");
            //       let arr = that.list;
            //       if (formData.search_cnbnum == "") {
            //         that.list = that.billOrder;
            //         return;
            //       }
            //       that.list = arr.filter(
            //         item =>
            //           item.search_cnbnum
            //             .toLowerCase()
            //             .indexOf(formData.search_cnbnum.toLowerCase()) !== -1
            //       );
            //     }
            //   },
            //   bind: {
            //     suffix: "ios-search",
            //     search: true
            //   }
            // }
          ],
          table: {
            config: {
              height: 300,
            },
            fields: [
              {
                type: "checkbox",
                width: 60,
                fixed: "left",
              },
              {
                name: () => this.$t("order_number"),
                key: "airway_bill_number",
                minWidth: 100,
              },
              {
                name: () => this.$t("reChAmount"),
                key: "amount",
                align: "left",
                minWidth: 100,
                // methods: {
                //   render() {
                //     return options.find(
                //       item =>
                //         item.value ==
                //         this.getModal("add").$refs["form"].formData.period
                //     ).label;
                //   }
                // }
              },
              // {
              //   name: () => this.$t("salesman"),
              //   key: "salesman_account",
              //   align: "left",
              //   minWidth: 100
              // }
            ],
          },
        },
        rate: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("b2bReStatistics", row)
                .then((res) => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg,
                  });
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 120,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              to_currency: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
              rate: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [{ to_currency: 24 }, { rate: 24 }],
          fields: [
            {
              name: this.$t("toCurrency"),
              key: "to_currency",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("toCurrency"),
              options: [
                { label: this.$t("to_rmb"), value: "CNY" },
                { label: this.$t("to_usd"), value: "USD" },
              ],
            },
            {
              name: () => this.$t("rate"),
              key: "rate",
              component: "InputNumber",
              bind: {
                min: 0,
                step: 0.0001,
                style: "width:100%",
              },
              default: 0,
            },
          ],
        },
        showDetails: {
          contentSlot: "DETAILS",
          config: {
            modalBind: {
              draggable: true,
              transfer: true,
              width: 1500,
            },
          },
          footer: { show: () => false },
        },
      },
      footer: {
        show: () => true,
        // render: h => {
        //   return h(
        //     "div",
        //     {
        //       class: "footer-content"
        //     },
        //     this.totalAmount.map(item => {
        //       return h(
        //         "div",
        //         {
        //           class: "footer-content-item"
        //         },
        //         [
        //           h("span", { class: "span-head" }, item.text),
        //           h(
        //             "span",
        //             { class: "span-head" },
        //             item.replace_currency + ":"
        //           ),
        //           h(
        //             "span",
        //             {
        //               class: "span-title"
        //             },
        //             numFun.formatNum(parseFloat(item.total_amount))
        //           )
        //         ]
        //       );
        //     })
        //   );
        // }
      },
      header: {
        config: {
          custom: false,
        },
        searchs: [
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 1, maxRows: 2 },
            },
          },
        ],
        btns: {
          list: [
            {
              name: this.$t("export"),
              type: "export",
              fnName: "export",

              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
            {
              name: this.$t("hang"),
              type: "hang",
              fnName: "hang",
              bind: {
                icon: "md-trash",
                type: "error",
              },
              disabled() {
                return !this.selectAll.length;
              },
            },
            {
              name: this.$t("delete"),
              type: "delete",
              fnName: "delete",
              bind: {
                icon: "md-trash",
                type: "error",
              },
              disabled() {
                return !this.selectAll.length;
              },
            },
          ],
          methods: {
            // 导出
            export({ searchForm }) {
              let data = searchForm;
              data.export = 1;
              data.ids = this.selectAll.map((item) => item.id);
              this.handleRequestMethods("list", data, false, true).then(
                (res) => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg,
                  });
                  window.open(this.$globalUrl + res.payload);
                }
              );
            },
            hang() {
              this.getModal("hang").open({}, function () {
                this.setTitle(this.$t("hang"));
              });
            },
            delete() {
              this.$Modal.confirm({
                title: this.$t("whether") + this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  let data = {
                    id: this.config.rows.id,
                    ids: this.selectAll.map((item) => {
                      return item.id;
                    }),
                  };
                  this.handleRequestMethods("deleteDetails", data).then(
                    (res) => {
                      this.$Message["success"]({
                        background: true,
                        content: res.msg,
                      });
                      this.getList();
                    }
                  );
                },
              });
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          width: 60,
        },
        {
          name: () => this.$t("outbound_time"),
          key: "outbound_time",
          width: 120,
        },
        // {
        //   name: () => this.$t("clientName"),
        //   key: "client_account",
        //   minWidth: 100,
        // },
        {
          name: () => this.$t("type"),
          key: "type",
          minWidth: 100,
        },
        {
          name: () => this.$t("order_number"),
          key: "airway_bill_number",
          minWidth: 130,
        },
        {
          name: () => this.$t("warehouseName"),
          key: "warehouse_name",
          width: 120,
        },
        {
          name: () => this.$t("countryName"),
          key: "to_country",
          minWidth: 100,
          align: "left",
        },
        {
          name: () => this.$t("channel_code"),
          key: "transport_mode",
          width: 100,
        },
        {
          name: () => this.$t("charge_volume"),
          key: "charge_volume",
          minWidth: 100,
        },
        {
          name: () => this.$t("charge_params"),
          key: "charge_params",
          minWidth: 100,
        },
        {
          name: () => this.$t("values"),
          key: "values",
          minWidth: 100,
        },
        {
          name: () => this.$t("rate"),
          children: [
            {
              name: () => this.$t("freight_fees"),
              key: "freight_unit_to_cny_rate",
              minWidth: 120,
            },
            {
              name: () => this.$t("taxFee"),
              key: "tax_currency_to_cny_rate",
              minWidth: 120,
            },
          ],
        },
        {
          name: () => this.$t("OriginalCurrency"),
          children: [
            {
              name: () => this.$t("freight_fees"),
              key: "freight_fees",
              minWidth: 120,
            },
            {
              name: () => this.$t("express_currency"),
              key: "freight_unit",
              minWidth: 120,
            },
            {
              name: () => this.$t("total_tax"),
              key: "total_tax",
              minWidth: 120,
            },
            {
              name: () => this.$t("taxCurrency"),
              key: "tax_currency",
              minWidth: 120,
            },

            {
              name: () => this.$t("vat_fee"),
              key: "vat_fee",
              minWidth: 130,
            },
            {
              name: () => this.$t("tax_fee"),
              key: "tax_fee",
              minWidth: 120,
            },
            {
              name: () => this.$t("document_fee"),
              key: "document_fee",
              minWidth: 130,
            },
          ],
        },
        {
          name: () => "CNY",
          children: [
            {
              name: () => this.$t("freight_fees"),
              key: "freight_fees_cny",
              minWidth: 120,
            },
            {
              name: () => this.$t("total_tax"),
              key: "total_tax_cny",
              minWidth: 120,
            },
            {
              name: () => this.$t("vat_fee"),
              key: "vat_fee_cny",
              minWidth: 130,
            },
            {
              name: () => this.$t("tax_fee"),
              key: "tax_fee_cny",
              minWidth: 120,
            },
            {
              name: () => this.$t("document_fee"),
              key: "document_fee_cny",
              minWidth: 130,
            },
          ],
        },
        {
          name: () => this.$t("otherCost"),
          children: [
            {
              name: () => this.$t("overload_fee"),
              key: "ext_material_fee",
              minWidth: 80,
            },
            {
              name: () => this.$t("extra_charge"),
              key: "ext_op_fee",
              minWidth: 80,
            },
            {
              name: () => this.$t("overload_fee"),
              key: "ext_overload_fee",
              minWidth: 80,
            },
            {
              name: () => this.$t("overweight_fee"),
              key: "ext_overweight_fee",
              minWidth: 80,
            },
            {
              name: () => this.$t("remote_fee"),
              key: "remote_fee",
              minWidth: 80,
            },
          ],
        },
        {
          name: () => this.$t("freight_append"),
          key: "freight_append",
          minWidth: 120,
          fixed: "right",
          // render: (h, params) => {
          //   return h("div", [
          //     h(
          //       "Button",
          //       {
          //         props: {
          //           type: "primary",
          //           size: "small"
          //         },
          //         on: {
          //           click: () => {
          //             this.crudClick(params.row);
          //           }
          //         }
          //       },
          //       params.row.freight_append
          //     )
          //   ]);
          // }
        },
      ],
    };
  },
};
</script>
